import getValueReduxUtil from 'modules/redux/utils/get-value'
import { WORKOUT_KEY } from 'modules/training/models/workout/constants'

function getNotesWorkoutUtil (instance) {
  return getValueReduxUtil(
    instance, WORKOUT_KEY.NOTES
  ) || ''
}

export default getNotesWorkoutUtil
